import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../DatePicker/DatePicker';
import classNames from 'classnames';
import moment from 'moment';

const LabeledDatePicker = (props) => {
    
    const divClassValue = classNames(
        'form-group',
        props.className
    );
    const classValue = classNames(
        'form-control',
        props.className
    );
    return(
        <div className="col-xs-12">
            <div className={divClassValue}>
                <label
                    htmlFor= {props.id}>
                    {props.label}
                </label>
                <DatePicker
                    className={classValue}
                    name={props.name}
                    selected={props.selectedDate}
                    onChange={props.onChange}/>
            </div>
        </div>
    );
};

LabeledDatePicker.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    selectedDate: PropTypes.object
};

export default LabeledDatePicker;


// WEBPACK FOOTER //
// ./src/components/base/LabeledDatePicker/LabeledDatePicker.js